'use client';
import React, { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import useIsLarge from './useIsLarge';

const DotLottieReact = dynamic(
  () => import('@lottiefiles/dotlottie-react').then((m) => m.DotLottieReact),
  { ssr: false, loading: () => null }
);

export default function LottieSlideshow({ height = '100%', className }) {
  const isLarge = useIsLarge(768);
  const slides = [
    '/images/HoldingLaptop.png',
    '/images/HoldingLaptop2.png',
    '/images/HoldingLaptop3.png',
  ];

  const isLottie = (src) => src.endsWith('.lottie');
  const [index, setIndex] = useState(0);
  const hostRef = useRef(null);
  const [inView, setInView] = useState(false);

  // Rotate slides on ALL screen sizes
  useEffect(() => {
    const id = setInterval(
      () => setIndex((i) => (i + 1) % slides.length),
      4000
    );
    return () => clearInterval(id);
  }, [slides.length]);

  // Intersection observer on ALL screen sizes
  useEffect(() => {
    const el = hostRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: '200px' }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const currentSrc = slides[index];
  const shouldShow = inView;
  const resolvedHeight = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      ref={hostRef}
      className={className}
      style={{
        position: 'relative',
        width: '100%',
        height: resolvedHeight,
        minHeight: isLarge ? undefined : '200px',
      }}
      aria-label="slideshow"
    >
      {isLottie(currentSrc) ? (
        shouldShow ? <DotLottieReact src={currentSrc} loop autoplay /> : null
      ) : (
        shouldShow ? ( <Image
            key={currentSrc}
            src={currentSrc}
            alt="Slideshow image"
            fill
            sizes={isLarge ? '460px' : '230px'}
            style={{ objectFit: 'contain' }}
            priority={index === 0}
          />
        ) : null)}
    </div>
  );
}